const i="wix-rich-content-plugin-spoiler";export{i as SPOILER_TYPE};
//# sourceMappingURL=types.js.map
